<template>
  <div class="form-floating mb-3">
    <input
        @input="handleInput"
        type="number"
        class="form-control"
        :id="property"
        :value="value"
        placeholder="name@example.com"
        :class="{'is-invalid': error }"
    >
    <label :for="property">{{ name }} <span class="text-danger" v-if="isRequired">*</span> </label>
    <message-error :code="errorCode" :hasError="error"/>
  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'NumberField',
  components: { MessageError },
  props: {
    value:{},
    property:{},
    name:{},
    error:{},
    isRequired:{},
    errorCode:{ type: String }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', parseInt(e.target.value))
    }
  }
}
</script>

<style scoped>
input{
  border-radius: 0 !important;
}
</style>
